import { AsyncPipe } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IconComponent } from "../../../../icon/icon.component";

@Component({
    selector: "rask-layer-error-message",
    templateUrl: "./layer-error-message.component.html",
    styleUrl: "./layer-error-message.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IconComponent,
        AsyncPipe
    ]
})
export class LayerErrorMessageComponent {

    errorListSource = new BehaviorSubject<string[]>([]);
    errorList$ = this.errorListSource.asObservable();

    @Input()
    set layerNames(value: string[]) {
        this.errorListSource.next(value);
    }
}
